import { render, staticRenderFns } from "./index-course.vue?vue&type=template&id=f1a819d2&scoped=true&"
import script from "./index-course.vue?vue&type=script&lang=js&"
export * from "./index-course.vue?vue&type=script&lang=js&"
import style0 from "./index-course.vue?vue&type=style&index=0&id=f1a819d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1a819d2",
  null
  
)

export default component.exports